import React, { useState } from 'react';
import styles from './SuperLessonNew.module.scss';
import Header from '@components/header/Header';
import EditLessonForm, { EditSllLesson } from '../edit/edit-lesson/EditLesson';
import { useHistory } from 'react-router-dom';
import { uploadFile } from '@services/File';
import { useSllCreateLessonMutation } from '@api/graphql-codegen';
import { gradeLabelPositionOptions } from '@constants';
import { useToast } from '@src/hooks/useToast';
import { useAWSKeys } from '@src/hooks';
import { logger } from '../../../../utils/logger';
import FooterPage from '@src/components/footer-page/FooterPage';

function SuperLessonNew() {
  const history = useHistory();
  const { successToast } = useToast();

  const { awsKeys } = useAWSKeys();

  const [createSllLesson] = useSllCreateLessonMutation({
    onCompleted(res) {
      if (res.sllCreateLesson) {
        successToast("Lesson is created successfully!");
      }
    },
    onError(e) {
      logger.debug(`[createHeaUnit error]-`, e);
      setLoading(false);
    },
  });

  const [loading, setLoading] = useState(false);

  const createNewLesson = async (p: EditSllLesson) => {
    try {
      setLoading(true);
      let coverImage;
      if (p.coverImage && typeof p.coverImage !== 'string') {
        coverImage = await uploadFile(awsKeys, p.coverImage, 'images');
      }
      let bannerImage;
      if (p.bannerImage && typeof p.bannerImage !== 'string') {
        bannerImage = await uploadFile(awsKeys, p.bannerImage, 'images');
      }
      const priorLessons = JSON.parse(p.recommendedPrior || '[]');
      const nextLessons = JSON.parse(p.recommendedNext || '[]');
      const newLesson = await createSllLesson({
        variables: {
          input: {
            ...p,
            gradeLabelPosition: p.gradeLabelPosition || gradeLabelPositionOptions[2].value,
            comingSoonLabelPosition: p.comingSoonLabelPosition || gradeLabelPositionOptions[3].value,
            coverImage,
            bannerImage,
            recommendedPrior: priorLessons,
            recommendedNext: nextLessons
          },
        }
      });
      const newLessonId = newLesson.data?.sllCreateLesson?.id;

      setLoading(false);
      if (newLessonId) {
        history.push(`/super/lessons/edit/${newLessonId}`);
      }
    } catch (e) {
      logger.debug(`[e]`, e);
      setLoading(false);
    }
  };

  return (
    <>
      <Header/>
      <div className={styles.page}>
        <div className={styles.list}>
          <div className={styles.programName}>New Lesson</div>
        </div>
        <div className={styles.content}>
          <EditLessonForm loading={loading} onSave={createNewLesson} sllLesson={undefined} setLoading={setLoading} />
        </div>
        <FooterPage />
      </div>
    </>
  );
}

export default SuperLessonNew;
